import { createStore } from 'vuex';

let tp = false
if (window.navigator.userAgent.indexOf('TokenPocket') > -1) {
  tp = true
}

// console.log('tp', tp);

export default createStore({
  state: {
    isDark: false,
    address: '',
    step: 1,
    isTp: tp,
  },
  mutations: {
    setDark(state, payload) {
      state.isDark = payload;
    },
    setAddress(state, payload) {
      state.address = payload;
    },
    setStep(state, payload) {
      state.step = payload;
    },
    setTp(state, payload) {
      state.isTp = payload;
    },
  },
  actions: {},
  getters: {
    isDark(state) {
      return state.isDark;
    },
    address(state) {
      return state.address;
    },
    step(state) {
      return state.step;
    },
    isTp(state) {
      return state.isTp;
    },
  },
  modules: {},
});
